export default "__VITE_ASSET__BbwmcxFp__"